<template>
  <div class="center">
    <div style="display: flex; align-items: center; margin: 20px 0">
      <el-input
        style="width: 220px; margin-right: 10px"
        placeholder="请输入关键字"
        prefix-icon="el-icon-search"
        clearable
        v-model="queryParams.title"
      >
      </el-input>
      <el-date-picker
        style="margin-right: 10px"
        v-model="queryParams.createTimeStart"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="date"
        placeholder="开始日期"
      >
      </el-date-picker>
      <el-date-picker
        style="margin-right: 10px"
        v-model="queryParams.createTimeEnd"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="结束日期"
      >
      </el-date-picker>

      <el-button type="primary" icon="el-icon-search" @click="handleQuery"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="purchaseList"
      style="width: 100%"
      fit
      v-loading="loading"
      @row-click="rowClick"
    >
      <el-table-column
        prop="title"
        label="询比标题"
        align="center"
        show-overflow-tooltip
        class-name="column-title"
      >
      </el-table-column>

      <el-table-column label="发布时间" width="300" align="center">
        <template slot-scope="{ row }">
          <span>{{ parseTime(row.createTime, "{y}-{m}-{d}") }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
        :autoScroll="false"
      />
    </div>
  </div>
</template>
  
<script>
import {
  getNoticeList,
  getPurchaseList,
  getSupplierList,
  getRNoticeList,
  getEnquiryList,
} from "@/api/home";
export default {
  name: "xunjia",
  data() {
    return {
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: "",
        createTimeStart: "",
        createTimeEnd: "",
      },
      purchaseList: [],
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    rowClick(row) {
      window.open("/#/xdetails?id=" + row.id, "询比信息");
    },
    getList() {
      this.loading = true;
      if (this.queryParams.createTimeEnd) {
        if (this.queryParams.createTimeEnd.indexOf("23:59:59") > -1) {
        } else {
          this.queryParams.createTimeEnd =
            this.queryParams.createTimeEnd + " 23:59:59";
        }
      }
      getEnquiryList(this.queryParams).then((res) => {
        this.purchaseList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
  },
};
</script>

  